import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { verifyCode, resetFlags, addPhone } from "../../../redux/actions/AuthAction";
import { connect } from "react-redux";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import ValidatedInput from "../../../components/ValidatedInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const VerifyCode = ({ authFlags, authErrors, verifyCode, resetFlags, history, handleSubmit, user, addPhone }) => {
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (authErrors && authErrors.verifyCode) {
            toast.error(authErrors.verifyCode);
            setProcessing(false);
            resetFlags();
        }

        if (authFlags && authFlags.addPhoneSuccess) {
            resetFlags();
            toast.success('OTP has been sent to your registered phone number!');
        }

        if (authFlags && authFlags.verifyCodeSuccess) {
            resetFlags();
            history.push('/verified');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authErrors, authFlags]);


    const handleVerifyCode = (formData) => {
        const { verification_code } = formData;
        setProcessing(true);
        verifyCode({ verification_code });
    };

    const formatPhoneNumber = () => {
        const cleaned = ('' + user.phone_number).replace(/\D/g, '')
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
        return null
    };

    const resendCode = () => {
        const phone_number = user.phone_number;
        if (!phone_number) {
            history.push('/add-phone');
        } else {
            addPhone({ phone_number });
        }
    };

    return (
        <div className="account-setup-wrapper">
            <Form className="form-container" onSubmit={handleSubmit(handleVerifyCode)}>
                <div className="form-header mt-md-3 mt-0">
                    <h2>Enter your code</h2>
                    <span>Enter the code sent to +1 {formatPhoneNumber()} <br />This code will expire in 10 minutes.</span>
                </div>
                <FormGroup className="form-group-center">
                    <Row>
                        <Label sm={4} xs={3}>Code</Label>
                        <Col sm={8} xs={9} className="label-redirection">
                            <button type="button" className="btn btn-link" onClick={resendCode}>Resend Code</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Field component={ValidatedInput} type="Code" name="verification_code" />
                        </Col>
                    </Row>
                </FormGroup>
                <div className="button_wrapper">
                    <button className="btn button" type="submit" disabled={processing}>
                        VERIFY PHONE {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
                <div className="links-forgot">
                    <Link to='/add-phone'>Entered an incorrect phone number?</Link>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.verification_code) {
        errors.verification_code = 'Field is required';
    }
    return errors;
};

const mapStateToProps = state => ({
    authErrors: state.Auth.errors,
    authFlags: state.Auth.flags,
    user: state.Auth.user
});

const mapDispatchToProps = dispatch => ({
    verifyCode: payload => {
        dispatch(verifyCode(payload))
    },
    addPhone: payload => {
        dispatch(addPhone(payload))
    },
    resetFlags: payload => {
        dispatch(resetFlags())
    }
});

const VerifyCodeComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifyCode);

export default reduxForm({
    form: 'VerifyCodeForm',
    validate,
})(VerifyCodeComponent);
